module.exports = __webpack_public_path__ + "img/pinterest.89bcdf35.svg";